export const fetchSalonCategoriesIfNeeded = ({ salonId, areCategoriesFetched, dispatch, getCategories }) => {
  if (!salonId || areCategoriesFetched) return;
  dispatch(getCategories(salonId));
};
